import { render, staticRenderFns } from "./main.remisiones.vue?vue&type=template&id=25e5f360"
import script from "./main.remisiones.vue?vue&type=script&lang=js"
export * from "./main.remisiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports